import React from "react";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import trackEvent from "../../utils/appMetrics";

// Shown on Home to a class-running studio that has not created a class yet.
// The same question the Help Center guide asks, except nobody has to find
// the Help Center: pick how you charge and you land in the new-class form
// with the frequency already set. It disappears the moment a class exists.
//
// `marks` is [month 0-3, week 0-3, height] — the bars are when money lands
// across one term, which is the part owners recognise themselves in.
const OPTIONS = [
  {
    key: "monthly", label: "Monthly tuition", accent: "#00695F",
    summary: "One bill a month per family, for as long as they are enrolled.",
    marks: [[0, 0, 1], [1, 0, 1], [2, 0, 1], [3, 0, 1]],
  },
  {
    key: "per_term", label: "One fee per session", accent: "#007BFF",
    summary: "The term is paid once, up front.",
    marks: [[0, 0, 1.85]],
  },
  {
    key: "per_class", label: "By the class", accent: "#C97B00",
    summary: "You bill for the classes that actually happened.",
    marks: [[0, 0, 0.6], [0, 2, 0.6], [1, 0, 0.6], [1, 2, 0.6], [2, 0, 0.6], [2, 2, 0.6], [3, 0, 0.6], [3, 2, 0.6]],
  },
  {
    key: "drop_in", label: "Drop-in only", accent: "#A3455C",
    summary: "No enrollment. People turn up and pay for the night.",
    marks: [[0, 1, 0.6], [0, 3, 0.6], [1, 2, 0.6], [2, 0, 0.6], [2, 2, 0.6], [2, 3, 0.6], [3, 1, 0.6]],
  },
];

const Cadence = ({ marks, accent }) => (
  <Box style={{ display: "flex", alignItems: "flex-end", height: 20, borderBottom: "1px solid #E0E0E0", marginTop: 10 }} aria-hidden="true">
    {[0, 1, 2, 3].map((m) => (
      <Box key={m} style={{ flex: 1, height: "100%", position: "relative" }}>
        {marks.filter((k) => k[0] === m).map((k, i) => (
          <span
            key={i}
            style={{
              position: "absolute", bottom: 0, left: `${8 + k[1] * 22}%`,
              width: 3, borderRadius: "2px 2px 0 0",
              height: Math.min(18, 10 * k[2]), background: accent,
            }}
          />
        ))}
      </Box>
    ))}
  </Box>
);

const FirstClassPricing = () => {
  const choose = (opt) => {
    trackEvent("first_class_pricing_chosen", { frequency: opt.key });
    window.location.href = `/studio_classes?new=1&freq=${opt.key}`;
  };

  return (
    <Box
      className="juice-in"
      style={{
        background: "#fff", border: "1px solid #E0E0E0", borderRadius: 16,
        padding: 20, marginBottom: 20, boxShadow: "0 4px 6px rgba(0,0,0,.05)",
      }}
    >
      <Typography style={{ fontSize: 17, fontWeight: 600, color: "#1a1a1a" }}>
        Before your first class, how do you charge?
      </Typography>
      <Typography style={{ fontSize: 13.5, color: "#666666", marginTop: 3, marginBottom: 14, lineHeight: 1.5 }}>
        Pick one and we&rsquo;ll open the class form set up that way. Price lives on each class, so
        others can work differently later.
      </Typography>

      <Box style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(210px, 1fr))", gap: 10 }}>
        {OPTIONS.map((opt) => (
          <button
            key={opt.key}
            type="button"
            onClick={() => choose(opt)}
            style={{
              textAlign: "left", background: "#fff", border: "1px solid #E0E0E0",
              borderRadius: 12, padding: "13px 14px", cursor: "pointer",
              fontFamily: "inherit", transition: "border-color .15s, transform .15s",
            }}
            onMouseEnter={(e) => { e.currentTarget.style.borderColor = opt.accent; e.currentTarget.style.transform = "translateY(-1px)"; }}
            onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#E0E0E0"; e.currentTarget.style.transform = "none"; }}
          >
            <Typography style={{ fontSize: 14.5, fontWeight: 600, color: "#1a1a1a" }}>{opt.label}</Typography>
            <Typography style={{ fontSize: 12.5, color: "#666666", lineHeight: 1.45, minHeight: 36 }}>{opt.summary}</Typography>
            <Cadence marks={opt.marks} accent={opt.accent} />
          </button>
        ))}
      </Box>

      <Typography style={{ fontSize: 12, color: "#6B7280", marginTop: 12 }}>
        Not sure? <a href="/help" style={{ color: "#007BFF", fontWeight: 600, textDecoration: "none" }}>See what each one means →</a>
      </Typography>
    </Box>
  );
};

export default FirstClassPricing;
